<div class="  ">

  <div class="container text-center mt-5">
    <span style="color:var(--primary-color);" class="fs-2  ">Solicita una <span class="fw-bolder">Ambulancia </span> si necesitas: </span>
  </div>



  <div class="container px-4 py-5" id="featured-3">
    <div class="row g-5 py-5 row-cols-1 row-cols-lg-3">
      <div *ngFor="let service of services; let i = index" class="feature col text-center ">
        <div class="feature-icon d-inline-flex align-items-center  justify-content-center  ">
          <img style="color: var(--secondary-color)" ngSrc="./assets/img/ambulancia/{{service.imagen}}" class="" alt="" height="40" width="40">
        </div>
        <p class=" fw-bolder fs-4" style="color: var(--primary-color)">{{service.name}}</p>
        <span class="text-secondary ">{{service.descripcion}}</span>

      </div>


    </div>
  </div>

  <div class="container py-5 ">
    <div class="container text-center">
      <p class=" fs-2 pt-2 " style="color: var(--primary-color)"><span class="fw-bolder">Solicita</span>  el servicio al:</p>

    </div>
    <div class="container py-2">

      <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
        <button class="buttonAction d-flex align-items-center  ">
          <img ngSrc="assets/img/movilink/llamadaIcon.svg" alt="llamadaLogo" class=" flex-shrink-0" height="30" width="30">
          <span class="text-light px-2 fs-1">5 50 50 52</span>
        </button>
        <a href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&ap+p_absent=0" class="buttonAction d-flex align-items-center justify-content-center">
          <img ngSrc="assets/img/movilink/whatsapLogo.svg" alt="whatsapLogo" class=" flex-shrink-0" height="30" width="30">
          <span class="text-light px-2 fs-1">099 318 3975</span>
        </a>
      </div>
    </div>

  </div>


</div>
